import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 25,
    type: CHECKLIST_ITEM_TYPE.MULTIPLE_CHOICE,
    manifestKey: 'MULTIPLE_CHOICE',

    try_it: {
        button_label: 'Select Choice(s)',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'MultipleChoiceCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { selected: 'option_a' },
        },
    },
    pre_flight_diff: [
        'Inline dropdown/menu opens showing action_config.choices options',
        'User selects one or more choices',
        'Checklist item: PENDING → YES',
        'Selected value(s) stored in response_payload.selected',
        '⚠ No choices whitelist on BE — any string accepted (out-of-scope ticket #3)',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'POST choices=[NOT_IN_OPTIONS] (arbitrary string)',
            body: {
                completion_state: 'YES',
                response_payload: { selected: 'NOT_IN_OPTIONS' },
            },
            expected: '200 accepted — BE does not validate against action_config.choices whitelist (confirms gap)',
        },
        {
            label: 'POST choices=[] (empty array)',
            body: {
                completion_state: 'YES',
                response_payload: { selected: [] },
            },
            expected: '200 accepted — no minimum-selection validation',
        },
    ],
};
